<ngx-spinner
    name="dialogSpinner"
    bdColor="rgba(0, 0, 0, 0.65)"
    size="medium"
    color="#fff"
    type="ball-clip-rotate"
    [fullScreen]="true">
    <p style="color: white; margin-top: 20px;">
        Loading advertisers...
    </p>
</ngx-spinner>
<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<form class="dialog-body" [formGroup]="form" (ngSubmit)="onAccept()">
    <div class="modal-body">
        <div class="main-card mb-3 card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <h2 class="card-title">{{ mode === GroupShareDialogModeEnum.EditGroupShare ? 'Edit Group' : 'New Group'}}</h2>
                        <input
                            id="groupName"
                            type="text"
                            class="form-control"
                            formControlName="groupName"
                            placeholder="Group name...">
                        <small *ngIf="groupNameControl.invalid && groupNameControl.touched" class="text-danger">
                            Group name is required
                        </small>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-12">
                        <h2 class="card-title">Platform</h2>
                        <div class="main-card mb-3 card">
                            <div class="card-body platform-selector-card">
                                <div class="platform-options">
                                    <button
                                        *ngFor="let platform of availablePlatforms"
                                        type="button"
                                        class="platform-option"
                                        [class.platform-option-selected]="isPlatformSelected(platform.id)"
                                        (click)="selectPlatform(platform)">
                                        <img class="platform-option-icon" [src]="platform.icon" [alt]="platform.name">
                                        <span class="platform-option-name">{{ platform.name }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <small *ngIf="form.get('targetPlatform')?.invalid && form.get('targetPlatform')?.touched" class="text-danger">
                            Platform is required
                        </small>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col list-column">
                        <ng-container *ngTemplateOutlet="businessList;
                                context: {
                                    side: GroupShareListSideEnum.Available,
                                    list: lists[GroupShareListSideEnum.Available],
                                    title: 'Businesses'
                                }
                            ">
                        </ng-container>
                    </div>
                    <div class="transfer-column d-flex align-items-center justify-content-center">
                        <div class="transfer-buttons">
                            <button
                                type="button"
                                class="btn transfer-button transfer-button-add"
                                [disabled]="lists[GroupShareListSideEnum.Available].selectedKeys.size === 0"
                                (click)="moveSelected(GroupShareListSideEnum.Available)">
                                <span>ADD</span>
                                <i class="fa fa-angle-double-right"></i>
                            </button>
                            <button
                                type="button"
                                class="btn transfer-button transfer-button-remove"
                                [disabled]="lists[GroupShareListSideEnum.Group].selectedKeys.size === 0"
                                (click)="moveSelected(GroupShareListSideEnum.Group)">
                                <i class="fa fa-angle-double-left"></i>
                                <span>REMOVE</span>
                            </button>
                        </div>
                    </div>
                    <div class="col list-column">
                        <ng-container *ngTemplateOutlet="
                                businessList;
                                context: {
                                    side: GroupShareListSideEnum.Group,
                                    list: lists[GroupShareListSideEnum.Group],
                                    title: 'Group'
                                }
                            ">
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="dismiss()">Cancel</button>
        <button
            type="submit"
            class="btn btn-primary"
            [disabled]="form.invalid || lists[GroupShareListSideEnum.Group].businesses.length === 0">
            {{ mode === GroupShareDialogModeEnum.EditGroupShare ? 'Save' : 'Create' }}
        </button>
    </div>
</form>
<ng-template #businessList let-side="side" let-list="list" let-title="title">
    <div class="main-card mb-3 card business-list-card">
        <div class="card-body">
            <h2 class="card-title">{{ title }}</h2>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="pe-7s-search"></i></span>
                </div>
                <input
                    type="text"
                    class="form-control"
                    placeholder="Search businesses or advertisers..."
                    [(ngModel)]="list.search"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onSearchChange(side)">
            </div>
            <div *ngIf="loadingBusinesses" class="text-center text-muted py-4">
                Loading businesses...
            </div>
            <ng-container *ngIf="!loadingBusinesses">
                <ng-container *ngIf="getBusinesses(side) as filteredBusinesses">
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th style="width: 35%">Business ID</th>
                                    <th style="width: 45%">Business name</th>
                                    <th class="text-center" style="width: 20%">Advertisers</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let business of getBusinesses(side,true)">
                                    <tr
                                        class="group-row"
                                        [class.table-primary]="isSelected(side,business)"
                                        [class.business-row-partial]="isPartiallySelected(side,business)"
                                        [class.group-row-expanded]="isExpanded(side,business.id)"
                                        role="button"
                                        tabindex="0"
                                        [attr.aria-expanded]="isExpanded(side,business.id)"
                                        (click)="toggleSelection(side,business)"
                                        (keydown.enter)="toggleSelection(side,business)"
                                        (keydown.space)="toggleSelection(side,business);$event.preventDefault()">
                                        <th scope="row" class="align-middle" style="word-break: break-word">
                                            <button
                                                type="button"
                                                class="btn btn-link p-0 mr-2"
                                                title="Show advertisers"
                                                [attr.aria-expanded]="isExpanded(side,business.id)"
                                                (click)="toggleExpanded(side,business.id);$event.stopPropagation()">
                                                <i
                                                    class="fa"
                                                    [ngClass]="isExpanded(side,business.id) ? 'fa-chevron-down' : 'fa-chevron-right'">
                                                </i>
                                            </button>
                                            {{ business.id }}
                                        </th>
                                        <td class="align-middle">{{ business.name }}
                                        </td>
                                        <td class="align-middle text-center">{{ business.items?.length || 0 }}</td>
                                    </tr>
                                    <tr class="group-detail-row">
                                        <td colspan="3" class="group-detail-cell p-0">
                                            <div class="group-detail-content" [ngbCollapse]="!isExpanded(side, business.id)">
                                                <div class="p-3">
                                                    <div class="table-responsive">
                                                        <table class="table table-sm table-bordered mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 40%"> Advertiser ID</th>
                                                                    <th style="width: 60%">Advertiser name</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr
                                                                    *ngFor="let item of business.items"
                                                                    class="advertiser-selection-row"
                                                                    [class.table-primary]="isSelected(side,business,item)"
                                                                    role="button"
                                                                    tabindex="0"
                                                                    (click)="toggleSelection(side,business,item)"
                                                                    (keydown.enter)="toggleSelection(side,business,item)"
                                                                    (keydown.space)="toggleSelection(side,business,item);$event.preventDefault()">
                                                                    <td class="align-middle" [title]="item.id">{{ item.id }}</td>
                                                                    <td class="align-middle" [title]="item.name">{{ item.name }}</td>
                                                                </tr>
                                                                <tr *ngIf="!business.items?.length">
                                                                    <td colspan="2" class="text-center text-muted py-3">
                                                                        No advertisers found
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr *ngIf="filteredBusinesses.length === 0">
                                    <td colspan="3" class="text-center text-muted py-4">
                                        No businesses found
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="list-pagination mt-3">
                        <ngb-pagination
                            *ngIf="filteredBusinesses.length > list.pageSize"
                            class="d-flex justify-content-center"
                            [(page)]="list.page"
                            [collectionSize]="filteredBusinesses.length"
                            [pageSize]="list.pageSize"
                            [maxSize]="3"
                            [rotate]="true"
                            [ellipses]="false"
                            [boundaryLinks]="true"
                            size="sm">
                        </ngb-pagination>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-template>